"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgCornerUpLeft = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M21.707 25.293a1 1 0 01-1.414 1.414l-5-5-.073-.082a1.003 1.003 0 01-.007-.008l.08.09A1.008 1.008 0 0115 21.02 1 1 0 0115 21v-.018c0-.024.002-.048.004-.071L15 21a1.008 1.008 0 01.213-.617c.025-.031.051-.062.08-.09l5-5a1 1 0 011.414 1.414L18.414 20H28a5 5 0 015 5v7a1 1 0 01-2 0v-7a3 3 0 00-3-3h-9.586l3.293 3.293z",
    id: "corner-up-left_svg__a"
  }));
};

var _default = SvgCornerUpLeft;
exports.default = _default;